const params = new URLSearchParams(window.location.search);
const intentSource = [
    params.get('utm_campaign') || '',
    params.get('utm_term') || '',
    params.get('service') || '',
    window.location.pathname || ''
].join(' ').toLowerCase();

const variants = [
    {
        keys: ['wartung', 'support', 'security', 'sicherheit', 'security-update', 'security update', 'security-updates', 'security updates', 'update support', 'sla', 'monitoring', 'patches', 'patch', 'backup', 'backups'],
        eyebrow: 'TYPO3 Wartung, Security und laufende Betreuung',
        eyebrowMobile: 'TYPO3 Wartung & Security',
        copy: 'Ich halte TYPO3-Systeme kontrolliert aktuell: Updates, Patches, Monitoring, Rollen/Rechte, Backups und planbare Reaktionswege für laufende Plattformen.',
        copyMobile: 'TYPO3-Wartung, Security und Updates planbar direkt vom Senior.',
        cta: 'Wartungsgespräch anfragen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'Wartung ansehen',
        serviceNeedle: 'wartung',
        compassKey: 'security'
    },
    {
        keys: ['upgrade', 'update', 'lts', 'migration', 'v12', 'v13', 'v14'],
        eyebrow: 'TYPO3 Upgrade, LTS-Migration und Modernisierung',
        eyebrowMobile: 'TYPO3 Upgrade & Modernisierung',
        copy: 'Ich analysiere Version, Extensions, Composer-Stand, Schnittstellen und Go-Live-Risiken und setze TYPO3-Upgrades von gewachsenen Altversionen bis zur aktuellen LTS planbar um.',
        copyMobile: 'TYPO3-Upgrades mit klarer Risikoanalyse und sicherem Go-Live.',
        cta: 'Upgrade prüfen lassen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'Upgrade-Leistungen ansehen',
        serviceNeedle: 'upgrade',
        compassKey: 'upgrade'
    },
    {
        keys: ['performance', 'code-performance', 'code performance', 'php-performance', 'php performance', 'langsam', 'ladezeit', 'caching', 'cache', 'core web vitals', 'lcp', 'inp', 'datenbankabfragen', 'schnittstellen-code', 'schnittstellen code', 'api langsam', 'schnittstelle langsam', 'schnittstellen langsam'],
        eyebrow: 'TYPO3 Performance, Code-Optimierung und Caching',
        eyebrowMobile: 'TYPO3 Performance',
        copy: 'Ich finde Engpässe in PHP-/Extension-Code, Datenbankabfragen, Schnittstellen, Caching und Frontend-Ausgabe und priorisiere Maßnahmen nach messbarer Wirkung.',
        copyMobile: 'Langsame TYPO3-/PHP-Stellen finden und messbar beschleunigen.',
        cta: 'Performance-Problem besprechen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'Performance-Leistungen ansehen',
        serviceNeedle: 'performance',
        compassKey: 'performance'
    },
    {
        keys: ['schnittstelle', 'schnittstellen', 'integration', 'integrationen', 'rest', 'api', 'erp', 'crm', 'business central'],
        eyebrow: 'TYPO3 Schnittstellen, Integrationen und Datenflüsse',
        eyebrowMobile: 'TYPO3 Schnittstellen & APIs',
        copy: 'Ich konzipiere und entwickle stabile Integrationen zwischen TYPO3 und Drittsystemen: REST/SOAP, CRM/ERP, Business Central, Suchindizes, Monitoring und nachvollziehbares Fehlerhandling.',
        copyMobile: 'TYPO3-Schnittstellen für ERP, CRM, Suche und Fachsysteme.',
        cta: 'Schnittstelle besprechen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'Schnittstellen ansehen',
        serviceNeedle: 'schnittstelle',
        compassKey: 'integration'
    },
    {
        keys: ['ki-anbindung', 'ki anbindung', 'kuenstliche intelligenz', 'künstliche intelligenz', 'ai-anbindung', 'openai', 'chatgpt', 'llm', 'rag', 'automatisierung', 'automation'],
        eyebrow: 'KI-Anbindung, Automatisierung und TYPO3-Workflows',
        eyebrowMobile: 'KI-Anbindung & Automatisierung',
        copy: 'Ich verbinde TYPO3-/PHP-Systeme pragmatisch mit LLM-APIs, RAG-nahen Suchprozessen, Redaktionshilfen und interner Automatisierung - mit sauberer Daten-, Rechte- und Fehlerlogik.',
        copyMobile: 'KI-Anbindungen für TYPO3, Suche und interne Workflows.',
        cta: 'KI-Anbindung besprechen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'Integrationen ansehen',
        serviceNeedle: 'ki-anbindung',
        compassKey: 'ki'
    },
    {
        keys: ['seo', 'suchmaschinenoptimierung', 'sichtbarkeit', 'indexierung', 'canonical', 'canonicals', 'redirect', 'redirects', 'schema', 'schema.org', 'snippet', 'snippets', 'ranking', 'rankings'],
        eyebrow: 'Technische SEO, Sichtbarkeit und TYPO3-Struktur',
        eyebrowMobile: 'Technische SEO',
        copy: 'Ich verbessere Indexierung, Canonicals, Redirects, strukturierte Daten, interne Verlinkung und technische SEO-Risiken in TYPO3 - besonders bei Relaunch, Migration und komplexen Templates.',
        copyMobile: 'Technische SEO für TYPO3-Struktur, Indexierung und Relaunchs.',
        cta: 'SEO-Potenzial besprechen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'SEO-Leistungen ansehen',
        serviceNeedle: 'seo',
        compassKey: 'seo'
    },
    {
        keys: ['freelancer', 'freiberufler', 'agentur', 'senior', 'lead', 'entwickler', 'expertise', 'erfahrung', 'architektur'],
        eyebrow: 'Senior TYPO3 Freelancer für Unternehmen und Agenturen',
        eyebrowMobile: 'Senior TYPO3 Freelancer',
        copy: 'Ich unterstütze kurzfristig bei Upgrades, Architektur, Code Reviews, Bugfixes, Integrationen, Suche und technischer Projektleitung, remote oder vor Ort in DACH.',
        copyMobile: 'Senior-Unterstützung für Upgrades, Architektur und Umsetzung.',
        cta: 'TYPO3-Erstgespräch anfragen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'Freelancer-Profil ansehen',
        serviceNeedle: 'agentur',
        compassKey: 'expertise'
    },
    {
        keys: ['schulung', 'schulungen', 'training', 'workshop', 'redaktion', 'developer'],
        eyebrow: 'TYPO3 Schulungen und Workshops',
        eyebrowMobile: 'TYPO3 Schulungen',
        copy: 'Praxisnahe TYPO3-Schulungen für Redaktionen, Entwicklerteams und Agenturen: individuell, remote oder vor Ort, mit Agenda aus echten Projektanforderungen.',
        copyMobile: 'TYPO3-Schulungen und Workshops nah an echten Projektfragen.',
        cta: 'Schulung anfragen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'Schulungsformate ansehen',
        serviceNeedle: 'schulung',
        compassKey: 'beratung'
    },
    {
        keys: ['notfall', 'rescue', 'fehler', 'bugfix', 'troubleshooting'],
        eyebrow: 'TYPO3 Troubleshooting und technische Zweitmeinung',
        eyebrowMobile: 'TYPO3 Troubleshooting',
        copy: 'Ich prüfe festgefahrene Updates, Fehler nach Releases, instabile Extensions, Performance-Probleme und unklare technische Risiken mit Senior-Blick.',
        copyMobile: 'TYPO3-Probleme schnell einordnen, stabilisieren und lösen.',
        cta: 'Problem einordnen lassen',
        ctaMobile: 'Erstgespräch anfragen',
        secondary: 'Leistungen ansehen',
        serviceNeedle: 'bugfix',
        compassKey: 'rescue'
    }
];

const variant = variants.find(({ keys }) => keys.some(key => intentSource.includes(key)));

const heroEyebrow = document.querySelector('#hero-eyebrow');
const heroCopy = document.querySelector('#hero-copy');
const ctaBtn = document.querySelector('#cta-button');
const secondaryCta = document.querySelector('#secondary-cta');

const setResponsiveText = (el, desktopText, mobileText = desktopText) => {
    const mobileSpan = document.createElement('span');
    mobileSpan.className = 'sm:hidden';
    mobileSpan.textContent = mobileText;

    const desktopSpan = document.createElement('span');
    desktopSpan.className = 'hidden sm:inline';
    desktopSpan.textContent = desktopText;

    el.replaceChildren(mobileSpan, desktopSpan);
};

if (variant) {
    if (heroEyebrow) setResponsiveText(heroEyebrow, variant.eyebrow, variant.eyebrowMobile);
    if (heroCopy) setResponsiveText(heroCopy, variant.copy, variant.copyMobile);
    if (ctaBtn) {
        setResponsiveText(ctaBtn, variant.cta, variant.ctaMobile || variant.cta);
        ctaBtn.setAttribute('aria-label', variant.cta);
    }
    if (secondaryCta) secondaryCta.textContent = variant.secondary;
    if (typeof window.activateServiceCompass === 'function') {
        window.activateServiceCompass(variant.compassKey);
    }
}

const selectService = (needle) => {
    const select = document.querySelector('#service');
    if (!select || !needle) return false;

    const normalizedNeedle = String(needle).toLowerCase();
    const match = [...select.options].find(option => {
        const text = option.textContent.toLowerCase();
        const value = option.value.toLowerCase();
        return text.includes(normalizedNeedle) || value.includes(normalizedNeedle);
    });

    if (match) {
        select.value = match.value || match.textContent;
        return true;
    }

    return false;
};

if (!selectService(params.get('service')) && variant?.serviceNeedle) {
    selectService(variant.serviceNeedle);
}

['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid', 'gbraid', 'wbraid'].forEach(key => {
    const el = document.getElementById(key);
    if (el) el.value = params.get(key) || '';
});
